<template>
  <div>
    <div class="add_car_header">
         <img @click="$emit('close')" class="float_right" src="./../imgs/叉 .png" alt=""  >
        <span>选购食材</span>
      </div>
      <div class="content_div" >
        <van-row style="margin:6px 0">
          <div>
          <span>主料商品</span>
          <div class="mgTop20">
            <div  class="mgTop20">
              <ul>
                <li
                  :class="{ cell_cover: item.salePrice == null, cook_li_mian: true }"
                 v-for="item in info.tradeCookbookDtlDTOS.filter(
                  (el) => el.classifyValue == 0
                )"
                :key="item.skuId"
                >
                <div class='cover_img'>
                  <img :src="item.picUrl" alt />
                </div>
                  <div class="inline detail_li">
                    <div class="goods_over">
                      {{ item.goodsName + "(" + item.skuName + ")" }}
                    </div>
                      <div  class="" >
                      <div   class="text_yellow" v-if="item.salePrice == null"
                        >商品失效</div
                      >
                      <div class="ty-left text_yellow" v-else
                        >
                         <div class='fSize_12 text_999' >¥{{item.parameter | filterNumTwo}}/{{item.goodsUnitLabel}}</div>
                        <span class="ty-left text_yellow"  >¥{{ item.salePrice | filterNumTwo}} /
                        <span class="fSize_10">
                             {{item.saleUnitLabel | filterUnit(item.saleRatio, item.goodsUnitLabel)}}
                        </span>
                       </span>
                        <span class="float_right step_fixed_Chose" >
                           <van-icon size="26px" color="#74B42B" name="add" @click='addOneCart(item)'  v-if='item.orderQty == 0' />
                        <van-stepper
                        v-else
                                  :min="0"
                                  class="stepper"
                                  button-size="24px"
                                  input-width="24px"
                                  integer
                                  @plus='addCart(item)'
                                  @minus='addCart(item,"minus")'
                                  async-change
                                  @change="addCart(item)"
                                  v-model="item.orderQty"
                                  :disable-minus="
                                    item.orderQty <= 0 ? true : false
                                  "
                                />
                      </span>
                      </div
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="mgTop20">
          <span>辅料商品</span>
          <div class="mgTop20">
            <div  class="mgTop20">
              <ul>
                <li
                  :class="{ cell_cover: item.salePrice == null, cook_li_mian: true }"
                 v-for="item in info.tradeCookbookDtlDTOS.filter(
                  (el) => el.classifyValue == 1
                )"
                :key="item.skuId"
                >
                <div class='cover_img'>
                  <img :src="item.picUrl" alt />
                  </div>
                  <div class="inline detail_li">
                    <div class="goods_over">
                      {{ item.goodsName + "(" + item.skuName + ")" }}
                    </div>
                    
                    <div  class="">
                      <div  class="text_yellow" v-if="item.salePrice == null"
                        >商品失效</div
                      >
                      <div  class="ty-left text_yellow" v-else
                        >
                      <div class='fSize_12 text_999' >¥{{item.parameter | filterNumTwo}}/{{item.goodsUnitLabel}}</div>
                        <span class="ty-left text_yellow"  >¥{{ item.salePrice | filterNumTwo}} /
                        <span class="fSize_10">
                             {{item.saleUnitLabel | filterUnit(item.saleRatio, item.goodsUnitLabel)}}
                        </span>
                       </span>
                        <span class="float_right step_fixed_Chose">
                           <van-icon size="26px" color="#74B42B" name="add" @click='addOneCart(item)'  v-if='item.orderQty == 0' />
                        <van-stepper
                                  :min="0"
                                   v-else
                                  class="stepper"
                                  button-size="24px"
                                  input-width="24px"
                                  integer
                                  @plus='addCart(item)'
                                  @minus='addCart(item,"minus")'
                                  async-change
                                    @change="addCart(item)"
                                  v-model="item.orderQty"
                                  :disable-minus="
                                    item.orderQty <= 0 ? true : false
                                  "
                                />
                      </span>
                      </div
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        </van-row>
        <!-- 修改商品数量 -->
        <!-- <van-dialog
          confirmButtonColor="rgba(116, 180, 43, 1)"
          v-model="showDia"
          title="修改商品数量"
          show-cancel-button
          :beforeClose='beforeClose'
        >
          <input
            ref="dialog"
            @change="newOrderChange"
            type="text"
            v-model="changNum"
            class="changeInput"
          />
        </van-dialog> -->
      </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    info: {
      default: {
        tradeCookbookDtlDTOS: []
      }
    }
  },
  watch: {},
  mounted() {
    this.customerId = +localStorage.getItem("customerId");
  },
  data() {
    return {
      show: false,
      currentItem: {},
      customerId: "",
      changNum: 0,
      showDia: false
    };
  },
  methods: {
    change(item){
      this.addCart(item)
    },
    changgeGoods(index) {
      this.changNum = index.orderQty;
      this.currentItem = index;
      this.showDia = true;
    },
    addOneCart(item){
      item.orderQty = 1;
      this.addCart(item)
    },
    beforeClose(action, done) {
      if (action == "confirm") {
        if (
          this.changNum <= 0 ||
          String(this.changNum).length > 3 ||
          String(this.changNum).indexOf(".") == 1
        ) {
          this.$toast("商品数量必须大于0并且小于四位数的整数");
          done(false);
        } else {
          this.changgeGoodsNumDan();
          done(true);
          // done()
        }
      } else {
        done();
      }
    },
    changgeGoodsNumDan() {
      let num = this.changNum;
      this.currentItem.orderQty = num;
      this.info.tradeCookbookDtlDTOS.forEach(item => {
        if (item.skuId == this.currentItem.skuId) {
          item.orderQty = this.currentItem.orderQty;
        }
      });
      this.addCart(this.currentItem);
    },
    newOrderChange() {
      this.changNum = this.$refs.dialog.value;
    },
    addCart(item, mark = "plus") {
      if (String(item.orderQty).length > 3) {
        this.$toast("商品数量必须大于0并且小于四位数的整数");
        return;
      }
      item.customerId = this.customerId;
      this.$axios.post("trade/tradeCart/save", item).then(res => {
        if (res.data) {
          if (mark == "minus") return;
          this.$toast("已修改购物车数量");
        }
      });
    }
  }
};
</script>

<style lang='scss' scoped>
/deep/ .van-field__control {
  width: 17%;
}
/deep/ .van-stepper {
  display: inline-block;
}

.cook_li {
  height: 100px;
  padding: 6px;
  width: 100%;
  display: inline-block;
  box-shadow: 0 0 3px rgba(153, 153, 153, 0.5) inset;
  border-radius: 5px;
  box-sizing: border-box;
  margin-bottom: 5px;
  img {
    width: 80px;
    float: left;
    height: 88px;
    background: rgba(247, 247, 247, 1);
    border-radius: 2px;
    margin-right: 10px;
  }
  .inline {
    display: inline-block;
    vertical-align: top;
    width: 70%;
  }
}
/deep/ .van-popup--bottom.van-popup--round {
  padding: 10px;
  box-sizing: border-box;
  .van-action-sheet__header {
    text-align: left;
  }
}
/deep/ .van-popup {
  overflow-y: hidden;
}
.stepper {
  /deep/ button {
    background-color: transparent;
  }
  /deep/ input {
    background-color: transparent;
  }
}
.content_div {
  overflow-y: auto;
  padding: 0px 10px;
  height: 74vh;
  width: 100%;
  box-sizing: border-box;
}
.add_car_header {
  padding: 12px 10px 16px 10px;
}
.step_fixed_Chose{
    position: absolute;
  bottom: 5px;
  right:6px;
  /deep/ .van-icon{
          bottom: -6px;
        }
  // position: absolute;
  // bottom:0;
  // right: 0;
  // /deep/ .van-icon{
  //   bottom: -3px;
  // }
}
// .cook_li_mian{
//   .inline{
//     height: 88px; overflow: hidden
//   }
//     position: relative;
//   .fixed_bottom{
//     position:absolute;
//     bottom: 30px;
//     width: 70%;
//   }
// }
</style>